// Client projects shown in the Work section. Descriptions come from what each
// live site actually does; screenshots are captured by scripts/capture-work.cjs.
export default [
  {
    name: "LTW Global Express",
    kind: "Shipping client portal",
    url: "https://ltwglobalexpress.com/welcome",
    host: "ltwglobalexpress.com",
    image: "/work/ltw-desktop.webp",
    imageSmall: "/work/ltw-desktop-1200.webp",
    tint: "lilac",
    body: "A package-forwarding service for Jamaica. Customers shop in the US and ship to their LTW Florida address, then use the client portal to track packages, check rates and estimate customs duty.",
    built: "Client portal and back end: customer accounts, package tracking, rates and a customs duty estimator",
  },
  {
    name: "Polaris",
    kind: "Applicant platform for a placement agency",
    url: "https://polarisja.com",
    host: "polarisja.com",
    image: "/work/polaris-desktop.webp",
    imageSmall: "/work/polaris-desktop-1200.webp",
    tint: "apricot",
    body: "The website and applicant platform for a licensed Jamaican agency that places students and graduates on US work, training and cultural exchange programmes. Applicants compare programmes and costs, then register and sign in online.",
    built: "Website, programme pages, applicant registration and sign-in",
  },
];
